export default "__VITE_ASSET__ChOJkRUF__"